export class MyErrorHandler {
    /** Builds the dialog payload. Pass `english = true` (used by the MDR pages) to get the
     *  English copy and flag the modal so its title/button are localised too. */
    static getText(error: any, english: boolean = false) {
        let resp: MyError = new MyError();
        const text = english ? ERROR_TEXTS.en : ERROR_TEXTS.it;

        if(error.status == 500) {
            resp.customText = text.generic;
            resp.customDetails = `${text.codeLabel}: 000`;
        } else if(error.error){
            resp.customText = text.handled;
            resp.customDetails = JSON.stringify(error.error);
        } else {
            resp.customText = text.unhandled;
            resp.customDetails = `${text.codeLabel}: 001`;
            console.error(error);
        }

        resp.english = english;
        return resp;
    }
}

export class MyError {
    customText: string | undefined;
    customDetails: string | undefined;
    english?: boolean;
}

const ERROR_TEXTS = {
    it: {
        generic: "Si è verificato un errore interno. Contatta l'assistenza per ricevere supporto.",
        unhandled: "Si è verificato un errore. Contatta l'assistenza per ricevere supporto.",
        handled: "Si è verificato un errore. Per risolvere, comunica i dettagli all'assistenza.",
        codeLabel: "Codice",
    },
    en: {
        generic: "An internal error occurred. Please contact support for assistance.",
        unhandled: "An error occurred. Please contact support for assistance.",
        handled: "An error occurred. To resolve it, please report the details to support.",
        codeLabel: "Code",
    },
} as const;

export const LOGIN_ERROR_WRONG: string = "wrongLogin";
export const LOGIN_ERROR_MISSING: string = "doLogin";

/** Shown (in English, MDR pages) when a restaurant can't be deleted because it's still
 *  referenced by an MDR request. */
export const RESTAURANT_IN_REQUESTS_MESSAGE: string =
  'You cannot delete the restaurant because it is included in a MDR request.';
